import axios from "axios";

export const state = {
    closedloans: [],
};

export const getters = {
    closedloans: state => state.closedloans,
};

export const mutations = {
    setClosedLoans(state, newValue) {
        state.closedloans = newValue
    },
};

export const actions = {
    async fetchClosedLoans({ commit }) {
        await axios.get('/closedloans').then(res => {
            commit('setClosedLoans', res.data.closedloans)
        })
    },
    async filterClosedLoans({commit}, {datefrom,dateto}) { 
        let formData = new FormData();
        formData.append("datefrom", datefrom);
        formData.append("dateto", dateto);
        let url = "/filterclosedloans";
        await axios.post(url, formData).then((response) => {
            commit('setClosedLoans', response.data.closedloans)
        })
    },
};
